import { render } from "./DepositMaintenanceLesotho.vue?vue&type=template&id=563484e2&scoped=true"
import script from "./DepositMaintenanceLesotho.vue?vue&type=script&lang=js"
export * from "./DepositMaintenanceLesotho.vue?vue&type=script&lang=js"

import "./DepositMaintenanceLesotho.vue?vue&type=style&index=0&id=563484e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563484e2"]])

export default __exports__